import { Component } from "@angular/core";
import { MdDialogRef } from "@angular/material";

@Component({
  selector: "error-dialog",
  template: require("./error-dialog.component.html"),
  styles: [require("./error-dialog.component.scss")]
})
export class ErrorDialogComponent {
  public constructor(public dialog: MdDialogRef<ErrorDialogComponent>) {}
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/components/forgot-password/error-dialog/error-dialog.component.ts